import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '@screen';
import styled from 'styled-components';

/**
 * Styled text component for event title in pause ad modal.
 * Displays the event name with regular font and text ellipsis for overflow.
 */
const PauseAdEventEventTitle = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${Screen.widthRatio * 24}px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
`;

export default PauseAdEventEventTitle;
